// import React, { useRef } from "react";
// import {
//   Box,
//   Button,
//   Grid,
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Typography,
// } from "@mui/material";
// import PrintIcon from "@mui/icons-material/Print";
// import { useReactToPrint } from "react-to-print";

// const StudentReportCard = () => {
//   const printRef = useRef();

//   // Function to print only the paper content
//   const handlePrint = useReactToPrint({
//     content: () => printRef.current,
//     documentTitle: "Student Report Card",
//     removeAfterPrint: true,
//   });

//   const subjects = [
//     { name: "English", written: 20, project: 10, slip: 15, test: 25 },
//     { name: "Hindi", written: 18, project: 9, slip: 14, test: 23 },
//     { name: "Maths", written: 22, project: 10, slip: 15, test: 26 },
//     { name: "Social", written: 19, project: 8, slip: 13, test: 20 },
//     { name: "G.K", written: 17, project: 7, slip: 12, test: 18 },
//   ];

//   const attendance = {
//     month: "August",
//     workingDays: 24,
//     presentDays: 22,
//   };

//   return (
//     <Box
//       sx={{
//         p: 3,
//         backgroundColor: "white",
//         borderRadius: 2,
//         boxShadow: 4,
//         margin: "5% 1% 1% 1%",
//       }}
//     >
//       {/* Header with Title & Print Button */}
//       <Box
//         display="flex"
//         justifyContent="space-between"
//         alignItems="center"
//         mb={2}
//       >
//         <Typography variant="h6" fontWeight="bold">
//           Report Card
//         </Typography>
//         <Button
//           variant="contained"
//           startIcon={<PrintIcon />}
//           onClick={handlePrint}
//           sx={{ backgroundColor: "#1976d2" }}
//         >
//           Print
//         </Button>
//       </Box>

//       {/* Report Card Paper */}
//       <Paper
//         ref={printRef}
//         sx={{
//           p: 3,
//           m: 5,
//           border: "1px solid #ccc",
//           borderRadius: 2,
//         }}
//       >
//         {/* School Header */}
//         <Box textAlign="center" mb={2}>
//           <Typography variant="h5" fontWeight="bold">
//             School Name
//           </Typography>
//           <Typography>Formative Assessment - I</Typography>
//           <Typography fontWeight="bold">Report Card</Typography>
//         </Box>

//         {/* Marks Table */}
//         <TableContainer>
//           <Table sx={{ border: "1px solid #ccc" }}>
//             <TableHead sx={{ backgroundColor: "#f5f5f5" }}>
//               <TableRow>
//                 {[
//                   "Sl. No",
//                   "Subject",
//                   "Written Work",
//                   "Project Work",
//                   "Slip Test",
//                   "Total",
//                   "Grade",
//                 ].map((head, idx) => (
//                   <TableCell
//                     key={idx}
//                     sx={{
//                       border: "1px solid #ccc",
//                       fontWeight: "bold",
//                       textAlign: "center",
//                     }}
//                   >
//                     {head}
//                   </TableCell>
//                 ))}
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {subjects.map((subj, index) => {
//                 const total =
//                   subj.written + subj.project + subj.slip + subj.test;
//                 const grade =
//                   total >= 90
//                     ? "A+"
//                     : total >= 75
//                     ? "A"
//                     : total >= 60
//                     ? "B"
//                     : "C";
//                 return (
//                   <TableRow key={index}>
//                     <TableCell sx={{ border: "1px solid #ccc" }}>
//                       {index + 1}
//                     </TableCell>
//                     <TableCell sx={{ border: "1px solid #ccc" }}>
//                       {subj.name}
//                     </TableCell>
//                     <TableCell sx={{ border: "1px solid #ccc" }}>
//                       {subj.written}
//                     </TableCell>
//                     <TableCell sx={{ border: "1px solid #ccc" }}>
//                       {subj.project}
//                     </TableCell>
//                     <TableCell sx={{ border: "1px solid #ccc" }}>
//                       {subj.slip}
//                     </TableCell>
//                     <TableCell sx={{ border: "1px solid #ccc" }}>
//                       {total}
//                     </TableCell>
//                     <TableCell sx={{ border: "1px solid #ccc" }}>
//                       {grade}
//                     </TableCell>
//                   </TableRow>
//                 );
//               })}
//             </TableBody>
//           </Table>
//         </TableContainer>

//         {/* Attendance Section */}
//         <Box mt={3} p={2} sx={{ border: "1px solid #ccc", borderRadius: 1 }}>
//           <Grid container spacing={2}>
//             <Grid item xs={4}>
//               <Typography>
//                 <strong>Month:</strong> {attendance.month}
//               </Typography>
//             </Grid>
//             <Grid item xs={4}>
//               <Typography>
//                 <strong>No. of Working Days:</strong> {attendance.workingDays}
//               </Typography>
//             </Grid>
//             <Grid item xs={4}>
//               <Typography>
//                 <strong>No. of Days Present:</strong> {attendance.presentDays}
//               </Typography>
//             </Grid>
//           </Grid>
//         </Box>

//         {/* Remarks */}
//         <Box
//           mt={3}
//           p={2}
//           sx={{ border: "1px solid #ccc", borderRadius: 1 }}
//           minHeight="50px"
//         >
//           <Typography>
//             <strong>Remarks:</strong>
//           </Typography>
//         </Box>

//         {/* Footer */}
//         <Box mt={3} display="flex" justifyContent="space-between">
//           <Typography>Class Teacher</Typography>
//           <Typography>Principal</Typography>
//           <Typography>Parent</Typography>
//         </Box>
//       </Paper>
//     </Box>
//   );
// };

// export default StudentReportCard;


import React, { useState } from "react";
import {
  Box,
  Paper,
  Typography,
  Button,
  Grid,
  Drawer,
  TextField,
} from "@mui/material";

const dummyStudents = [
  { id: 1, rollNo: 1, name: "Ganesh Kumar" },
  { id: 2, rollNo: 2, name: "Hamshith Bairapaka" },
  { id: 3, rollNo: 3, name: "Aadhya Sree" },
];

const categories = [
  { id: "project", label: "PROJECT", total: 30 },
  { id: "internals", label: "INTERNALS", total: 20 },
  { id: "sliptest", label: "SLIPTEST", total: 50 },
];

export default function StudentReportCard() {
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [formData, setFormData] = useState({});

  const handleOpen = (student, mode) => {
    setSelectedStudent({ ...student, mode });
    setFormData({}); // reset
    setOpenDrawer(true);
  };

  const handleClose = () => {
    setOpenDrawer(false);
    setSelectedStudent(null);
  };

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = () => {
    if (selectedStudent.mode === "enter") {
      console.log("POST Marks:", { student: selectedStudent, formData });
    } else {
      console.log("PATCH Marks:", { student: selectedStudent, formData });
    }
    handleClose();
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h5" sx={{ fontWeight: "bold", mb: 2 }}>
        Upload Students Marks
      </Typography>

      {dummyStudents.map((student) => (
        <Paper key={student.id} sx={{ p: 2, mb: 2 }}>
          <Grid container alignItems="center">
            {/* Student Details */}
            <Grid item xs={8}>
              <Typography variant="body1" fontWeight="bold">
                Roll No: {student.rollNo}
              </Typography>
              <Typography variant="body2">Name: {student.name}</Typography>
            </Grid>

            {/* Actions */}
            <Grid item xs={4} display="flex" justifyContent="flex-end" gap={1}>
              <Button
                variant="contained"
                size="small"
                onClick={() => handleOpen(student, "enter")}
              >
                Enter Marks
              </Button>
              <Button
                variant="outlined"
                size="small"
                onClick={() => handleOpen(student, "edit")}
              >
                Edit Marks
              </Button>
            </Grid>
          </Grid>
        </Paper>
      ))}

      {/* Drawer for Enter/Edit */}
      <Drawer
        anchor="right"
        open={openDrawer}
        onClose={handleClose}
        sx={{ "& .MuiDrawer-paper": { width: 500, p: 2 } }}
      >
        {selectedStudent && (
          <Box>
            <Typography variant="h6" fontWeight="bold" mb={2}>
              {selectedStudent.mode === "enter" ? "Enter Marks" : "Edit Marks"}{" "}
              - {selectedStudent.name}
            </Typography>

            {categories.map((cat) => (
              <TextField
                key={cat.id}
                label={`${cat.label} /${cat.total}`}
                type="number"
                fullWidth
                margin="dense"
                value={formData[cat.id] || ""}
                onChange={(e) => handleChange(cat.id, e.target.value)}
              />
            ))}

            <Box mt={2} textAlign="right">
              <Button
                variant="contained"
                onClick={handleSubmit}
                sx={{ bgcolor: "#3C3972", "&:hover": { bgcolor: "#2c2a56" } }}
              >
                {selectedStudent.mode === "enter" ? "Submit" : "Update"}
              </Button>
            </Box>
          </Box>
        )}
      </Drawer>
    </Box>
  );
}

